import { render } from "./LegacyClickBankTrigger.vue?vue&type=template&id=253a923d"
import script from "./LegacyClickBankTrigger.vue?vue&type=script&lang=js"
export * from "./LegacyClickBankTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script